import { useRouter } from 'next/router';
import React, { FunctionComponent } from 'react';
import { Wrapper, LinkButton, Text, MobileText } from './ProductsTabs.style';

interface LinkType {
  text: string;
  url: string;
  mobileText?: string;
  regex?: RegExp;
}

const tabs: LinkType[] = [
  { text: 'Why PropertyPal?', url: '/products' },
  {
    text: 'Estate Agents',
    mobileText: 'Agents',
    url: '/products/estate-agents',
    regex: /^\/(?:products\/estate-agents|estate-agent-websites|agent-advantage)(?:\/.*)?$/,
  },
  {
    text: 'Developers',
    mobileText: 'Developers',
    url: '/products/developers',
    regex: /^\/(?:products\/developers|development-microsites)(?:\/.*)?$/,
  },
];

interface ProductsTabsProps extends React.HTMLAttributes<HTMLDivElement> {}

const ProductsTabs: FunctionComponent<ProductsTabsProps> = ({ ...props }) => {
  const router = useRouter();

  return (
    <div {...props}>
      <Wrapper>
        {tabs.map((link) => (
          <LinkButton
            $active={router.pathname === link.url || !!(link.regex && router.pathname.match(link.regex))}
            key={link.text}
            data-testid={`product-link-${link.text.toLowerCase().replace(' ', '-')}`}
            type="button"
            prefetch={false}
            href={link.url}
          >
            <Text data-testid="product-text">{link.text}</Text>
            <MobileText data-testid="product-mobile-text">{link.mobileText || link.text}</MobileText>
          </LinkButton>
        ))}
      </Wrapper>
    </div>
  );
};

export default ProductsTabs;
